import { render, staticRenderFns } from "./NewRequestPage.vue?vue&type=template&id=4efc0606"
import script from "./NewRequestPage.vue?vue&type=script&lang=js"
export * from "./NewRequestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports